import React, {Component} from 'react';
import FavouriteAPI from "../classes/FavouriteAPI";

class Favourite extends Component {
  constructor(props) {
    super(props);
    this.state = {flagged:false};
    this.favouriteAPI = new FavouriteAPI();
    this.favouriteAPI.isFavourite(this.props.nid).then((isFavourite) => this.setState({flagged: isFavourite}));
    this.flagIt = this.flagIt.bind(this);
  }

  componentDidMount() {
    this.favouriteAPI.isFavourite(this.props.nid).then((isFavourite) => this.setState({flagged: isFavourite}));
  }

  flagIt() {
    if (this.favouriteAPI.favourite(this.props.nid)) {
      this.setState({flagged: !this.state.flagged})
    }
  }

  render() {
    let flag_class = (this.state.flagged ? 'action-unflag' : 'action-flag');
    return (
      <div className="venue__favourite">
        <div onClick={this.flagIt} className={"favourite flag-favourites js-flag-favourites-14 "+flag_class}>
          <span title="" href={drupalSettings.path.baseUrl + "flag/unflag/favourites/14?destination&amp;token=Ac14_7JGMK2FTIQB8RXgCEl4N2KSx7rkN1v-2i2mWzY"} className="use-ajax" rel="nofollow">
            <span className="favourite__title"></span>
            <span className="favourite__delete"></span>
          </span>
        </div>
      </div>
    );
  }
}

export default Favourite;
